/* content file: replace all html between <> </> with actual content */

export const AwardInfosec = () => { 
  return (
  <>
    <p>
      Der InfoSec Impact Award zeichnet innovative Lösungen aus, die zur Verbesserung der IT-Sicherheit in der Verwaltung beitragen. GA-Lotse wurde im Rahmen des Kongresses Digitale Stadt in Berlin ausgezeichnet.
    </p>
  </>    
  )
}